import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"video_list",
    list_id:"find_video_frame_list",
    x_column_list_arr:[
      {"key":"check_box","name":"체크","width":"30","is_show":"1"},
      {"key":"a_title","name":"제목","width":"100","is_show":"1"},
      {"key":"a_content","name":"내용","width":"100","is_show":"1"},
      //{"key":"a_total_sec","name":"시간(분)","width":"100","is_show":"1"},
      {"key":"row_view_time","name":"시간(분)","width":"100","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':100,
      'order_id':'a_order_num',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_title_seq","a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;